import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import axios from 'axios';

const API = process.env.REACT_APP_BACKEND_URL + '/api';

// Generate or retrieve session ID
const getSessionId = () => {
  let sessionId = sessionStorage.getItem('visit_session_id');
  if (!sessionId) {
    sessionId = `${Date.now()}-${Math.random().toString(36).substr(2, 9)}`;
    sessionStorage.setItem('visit_session_id', sessionId);
  }
  return sessionId;
};

/**
 * VisitTracker - Server-side analytics tracking
 * Logs page visits to the backend for analytics
 * GDPR compliant: IP is anonymized server-side
 */
const VisitTracker = () => {
  const location = useLocation();
  const lastTrackedPath = useRef(null);

  useEffect(() => {
    const trackVisit = async () => {
      // Don't track admin pages
      if (location.pathname.startsWith('/admin')) {
        return;
      }

      // Don't track the same page twice in a row (SPA navigation)
      if (location.pathname === lastTrackedPath.current) {
        return;
      }

      lastTrackedPath.current = location.pathname;

      try {
        await axios.post(`${API}/analytics/visit`, {
          page: location.pathname,
          referrer: document.referrer || '',
          user_agent: navigator.userAgent || '',
          session_id: getSessionId()
        });
      } catch (error) {
        // Silently fail - analytics should never block the user
        console.debug('Visit tracking failed:', error.message);
      }
    };

    // Small delay to not block initial page render
    const timer = setTimeout(trackVisit, 100);
    return () => clearTimeout(timer);
  }, [location.pathname]);

  // This component renders nothing
  return null;
};

export default VisitTracker;
